import { useTranslation } from 'react-i18next';
import { Button } from '../../components/Button';

import styles from './index.module.css';

interface ModifyAppointmentConfirmationViewProps {
  instructions: string;
  pending?: boolean;
  onModifyAppointment?: () => void;
  onClose?: () => void;
}

export const ModifyAppointmentConfirmationView: React.FC<
  ModifyAppointmentConfirmationViewProps
> = ({ instructions, pending, onModifyAppointment, onClose }) => {
  const { t } = useTranslation();
  return (
    <>
      <div className={styles.Instruction}>{instructions}</div>
      <div className={styles.CancelConfirmationButtons}>
        <Button
          className={styles.CancelConfirmationButton}
          type="button"
          onClick={onModifyAppointment}
          children={t('Yes')}
          disabled={pending}
        />
        <Button
          className={styles.CancelConfirmationButton}
          type="button"
          onClick={onClose}
          children={t('No')}
          disabled={pending}
        />
      </div>
    </>
  );
};
